import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    ButtonGroup
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import SingleCowPdf from '../components/SingleCowPdf';
import CowlistPdf, { CowlistPdfMulti } from '../components/CowlistPdf';
import CatalogPdf from '../components/CatalogPdf';
import { Close } from '@mui/icons-material';
import OtherlistPdf from '../components/OtherlistPdf';


export const ContainerPdfDialog = forwardRef(({ }, ref) => {

    const [open, setOpen] = useState(false);
    const [doc_data, setDocData] = useState([])
    const [data_list, setDataList] = useState([])
    const [title, setTitle] = useState('')
    const [p_type, setType] = useState('')
    const [is_multi, setIsMulti] = useState(false)
    const [page_split, setPageSplit] = useState(false)
    const pdfRef = useRef()




    useImperativeHandle(ref, () => {
        return {
            onOpen(el, _title, p_type, multi) {
                setOpen(true);
                setIsMulti(multi)
                if (el.data_list) {
                    setDataList(el.data_list)
                    setPageSplit(el.page_split)
                } else {
                    //    setDataList([{title: title, doc_data: el}])
                    setDataList(undefined)
                    setPageSplit(false)
                }
                setDocData(el)
                setType(p_type)
                setTitle(_title)
            },
        }
    })


    const handleClose = () => {
        setOpen(false);
    };

    const pdfItem = () => {
        if (p_type === 'singleboard') {
            return (
                <SingleCowPdf cow_list={doc_data} type="signboard" ref={pdfRef} />
            )
        } else if (p_type === 'number') {
            return (
                <SingleCowPdf cow_list={doc_data} type="number" ref={pdfRef} />
            )
            //<CowNumberPdf cow_list={doc_data} />
        } else if (p_type === 'catalog') {
            return (
                <CatalogPdf doc_data={doc_data} p_type={"catalog"}/>
            )
        } else if (p_type === 'group_print') {
            return (
                <CatalogPdf doc_data={doc_data} group={true} p_type={"group_print"}/>
            )
        } else if (p_type === 'cowman') {
            return (
                <OtherlistPdf doc_data={doc_data} p_type={p_type} />
            )
        } else if (p_type === 'property') {
            return (
                <OtherlistPdf doc_data={doc_data} p_type={p_type} />
            )
        } else if (p_type === 'globalsummary') {
            return (
                <OtherlistPdf doc_data={doc_data} p_type={p_type} />
            )
        } else {
            if (data_list) {
                return (
                    <CowlistPdfMulti doc_data={data_list} p_type={p_type} is_multi={is_multi} page_split={page_split}/>
                )
            } else {
                return (
                    <CowlistPdf doc_data={doc_data} p_type={p_type} is_multi={is_multi} />
                )
            }
        }

    }


    return (
        <Dialog open={open} onClose={handleClose} fullScreen={true}>
            <DialogTitle>
                {title}
            </DialogTitle>
            <DialogContent>
                {pdfItem()}
            </DialogContent>
            <DialogActions>
                <ButtonGroup>
                    <Button variant='outlined' key={'bc'} onClick={handleClose} startIcon={<Close />}>Chiudi</Button>
                </ButtonGroup>
            </DialogActions>
        </Dialog>

    )

})



